import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckedIconComponent } from './checked-icon.component';

@NgModule({
  declarations: [CheckedIconComponent],
  imports: [CommonModule],
  exports: [CheckedIconComponent]
})
export class CheckedIconModule {}
